import SideMenu from "../../../ui/SideMenu";
import useSubscriptionPlans from "../../../hooks/useSubscriptionPlans";
import { useSelector } from "react-redux";
import { BiBarcodeReader } from "react-icons/bi";
import styles from "../../../styles/Components/pricing-plan/new-plans/SubscriptionInfo.module.css";
import { GrStatusInfo } from "react-icons/gr";
import { FaDollarSign } from "react-icons/fa6";
import { GiDuration } from "react-icons/gi";
import { TiArrowLoop } from "react-icons/ti";
import CancelSubscriptionButton from "../billing/CancelSubscriptionButton";
import RenewSubscriptionButton from "../billing/RenewSubscriptionButton";
import { Skeleton } from "antd";

function SubscriptionInfo() {
  const {
    profile: { profileData },
  } = useSelector((state) => state);

  const { subscriptionData, subscriptionName, isLoading, isEnterprise } =
    useSubscriptionPlans();

  const {
    id,
    isCanceled,
    endDate,
    startDate,
    amount,
    interval: subscriptionInterval,
    planMode,
  } = subscriptionData;

  return (
    <SideMenu
      title={`
      ${subscriptionName} Subscription Details`}
      scope="subscription-info"
    >
      <div className={styles.summaryContainer}>
        {!isEnterprise && (
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>
              <BiBarcodeReader /> Subscription ID:
            </span>
            {isLoading ? (
              <Skeleton.Node active rootClassName={styles.loader} />
            ) : (
              <span className={styles.infoValue}>{id}</span>
            )}
          </div>
        )}
        {!isEnterprise && (
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>
              <GrStatusInfo /> Status:
            </span>
            {isLoading ? (
              <Skeleton.Node active rootClassName={styles.loader} />
            ) : (
              <span className={styles.infoValue}>
                {isCanceled ? "Cancelled" : "Active"}
              </span>
            )}
          </div>
        )}
        {!isEnterprise && (
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>
              <FaDollarSign /> Amount:
            </span>
            {isLoading ? (
              <Skeleton.Node active rootClassName={styles.loader} />
            ) : (
              <span className={styles.infoValue}>{amount / 100} USD</span>
            )}
          </div>
        )}
        {!isEnterprise && (
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>
              <TiArrowLoop /> Interval:
            </span>
            {isLoading ? (
              <Skeleton.Node active rootClassName={styles.loader} />
            ) : (
              <span className={styles.infoValue}>{subscriptionInterval}</span>
            )}
          </div>
        )}
        <div className={styles.infoItem}>
          <span className={styles.infoLabel}>
            <GiDuration /> {isEnterprise ? "Valid until" : "Current Period"}:
          </span>
          {isLoading ? (
            <Skeleton.Node active rootClassName={styles.loader} />
          ) : (
            <span className={styles.infoValue}>
              {!isEnterprise ? `${startDate} to ${endDate}` : endDate}
            </span>
          )}
        </div>
      </div>
      {profileData?.email && !isEnterprise && (
        <p style={{ marginTop: "1rem" }}>
          To see your subscription details and invoices or change credit card,
          VAT or address,{" "}
          <a
            href={`https://billing.stripe.com/p/login/4gw15yfxS0Xa2bKbII?prefilled_email=${profileData?.email.toLowerCase()}`}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "underline", color: "#0c4cfc" }}
          >
            please click here
          </a>
          .
        </p>
      )}

      {subscriptionName !== "Enterprise" && (
        <div className={styles.actionBtns}>
          <CancelSubscriptionButton
            subscription={subscriptionData}
            isActive={!isCanceled}
            subscriptionType={planMode}
          />
          <RenewSubscriptionButton
            isActive={!isCanceled}
            subscriptionType={planMode}
          />
        </div>
      )}
    </SideMenu>
  );
}

export default SubscriptionInfo;
